import { FormattedMessage } from 'components/shared/Intl';
import { LightAlert } from 'components/shared/LightAlert';
import { FC } from 'react';

export const WarningCallTrader: FC<{ className?: string }> = ({ className }) => (
  <LightAlert
    key="product-modification-call-trader-warning"
    severity="warning"
    e2e="product-modification-call-trader-warning"
    className={className}
  >
    <FormattedMessage id="productModification.sidePanel.warning.calltrader" />
  </LightAlert>
);
WarningCallTrader.displayName = 'callTraderWarning';
